import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"tile":""}},[_c(VContainer,{staticStyle:{"min-height":"100vh","height":"100%"}},[_c(VCard,{staticClass:"pa-3",attrs:{"tile":"","height":"100%"}},[_c('iframe',{attrs:{"src":"https://b2c.dev.anvio.com/ru/moscow/bookingwidget","width":"100%","height":"1000","frameborder":"0"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }